import { set_user_settings } from './wachat_utils';

export default class WachatUserSettings {
  constructor(wachat_list) {
    this.wachat_list = wachat_list;
    this.setup();
  }

  async setup() {
    this.user_settings_dialog = new frappe.ui.Dialog({
      title: __('My Settings'),
      fields: [
        {
          label: __('Enable Message Tone'),
          fieldname: 'enable_message_tone',
          fieldtype: 'Check',
          default: frappe.Wachat.settings.user.enable_message_tone,
        },
        {
          label: __('Enable Notifications'),
          fieldname: 'enable_notifications',
          fieldtype: 'Check',
          default: frappe.Wachat.settings.user.enable_notifications,
        },
        {
          label: __('WhatsApp Account'),
          fieldname: 'whatsapp_account',
          fieldtype: 'Link',
          options: 'WhatsApp Account',
          default: frappe.Wachat.settings.user.whatsapp_account,
        },
      ],
      action: {
        primary: {
          label: __('Save'),
          onsubmit: async (values) => {
            await set_user_settings(values);
            frappe.Wachat.settings.user.enable_message_tone =
              values.enable_message_tone;
            frappe.Wachat.settings.user.enable_notifications =
              values.enable_notifications;
            frappe.Wachat.settings.user = {
              ...frappe.Wachat.settings.user,
              ...values,
            };

            this.user_settings_dialog.hide();
            if (this.wachat_list) {
              // frappe.Wachat.instance.wachat_list.fetch_and_setup_rooms();
              this.wachat_list.fetch_and_setup_rooms();
              // await this.wachat_list.fetch_and_setup_rooms();
              // this.wachat_list.render();
            }
          },
        },
      },
    });
  }

  show() {
    this.user_settings_dialog.show();
  }
}
